import {ApiAttributeParams, CrudSettings, QueryParams} from "../shared/crud/abstractions/base-crud";
import {EnvironmentService} from "../core/environment/environment.service";
import {Injectable} from "@angular/core";
import {BasePagedCrudService} from "../shared/crud/base-crud.service";
import { HttpClient } from "@angular/common/http";
import {DefiniceVykazuFormatDto} from "./Models/DefiniceVykazuFormatDto";
import {BehaviorSubject, lastValueFrom} from "rxjs";
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export class DefiniceVykazuFormatCrud implements CrudSettings<string, DefiniceVykazuFormatDto>
{
  baseUrl = '';
  postUrl = '';
  queryParam = undefined;
  createSuffix = undefined;
  editPostfix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'Vse';
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity:  DefiniceVykazuFormatDto) => entity.kodUj;

  mapper(id: string,from?: ApiAttributeParams): QueryParams {
    const dict = new Map<string, string>();
    if(from)
    {
      dict.set(from,id)
      return { params: dict };
    }
    dict.set('id', id);
    return { params: dict };
  }
  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/DefiniceVykazu/Format';
  }
}

@Injectable
({
  providedIn: null
})
export class DefiniceVykazuFormatDataService
  extends BasePagedCrudService<string,DefiniceVykazuFormatDto,DefiniceVykazuFormatDto,DefiniceVykazuFormatDto>
{
  isBusy$: BehaviorSubject<boolean>;
  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new DefiniceVykazuFormatCrud(environmentService), dialogService);
    this.isBusy$ = new BehaviorSubject<boolean>(false)
  }

  public async getVykazyById(id: string): Promise<DefiniceVykazuFormatDto[]>
  {
    this.isBusy$.next(true)
    const res$ = this._http.get<DefiniceVykazuFormatDto[]>(`${this.getSettings().baseUrl}/DefiniceVykazu?idDefinice=${id}`)
    let res = await lastValueFrom(res$)
    this.isBusy$.next(false)
    return res;
  }
}

